import './App.css';
import DashboardLog from './dashboard/index.tsx';

function App() {
  if (window.location.pathname === '/' || window.location.pathname === '') {
    window.location.replace('/dashboard-log');
    return null;
  }

  if (window.location.pathname === '/dashboard-log') {
    return <DashboardLog />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Open <code>/dashboard-log</code> to view dashboard log.
        </p>
      </header>
    </div>
  );
}

export default App;
